import React, { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import { CreateGenerateFormInput } from './../../../../services/register_redux/register_actions/generateForm.action';
import { getUnits } from './../../../../services/global_redux/globale_actions/Unit.action';
import { getForm } from './../../../../services/register_redux/register_actions/Form.action';
import "./EmployeeGenerateForm.css";
import { useParams } from 'react-router-dom';
import Select from 'react-select';


function GenerateForm({ setLoading, showSnackbar }) {
  const defaultClientID = sessionStorage.getItem("selectedClient");
  const [clientID, setClientID] = useState(defaultClientID);
  const [clientName, setClientName] = useState("");
  const [formName, setFormName] = useState("");
  const [selectedUnit, setSelectedUnit] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [acts, setActs] = useState("");
  const [selectedForm, setSelectedForm] = useState("");
  const [clraAddress, setClraAddress] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [employeeData, setEmployeeData] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const dispatch = useDispatch();
  const { date } = useParams();

  useEffect(() => {
    if (defaultClientID) {
      fetchUnitIDs(defaultClientID);
    }
  }, [defaultClientID]);

  const formOptions = Array.isArray(formName)
  ? formName.map((form) => ({
      value: form.form_name,
      label: form.form_name,
    }))
  : [];


  const fetchUnitIDs = async (clientID) => {
    setLoading(true);
    try {
      const response = await dispatch(getUnits(clientID));
      const filteredUnits = response.data.filter(
        (unit) => unit.client_id === clientID
      );
      if (filteredUnits.length > 0) {
        setClientName(filteredUnits[0].client_name);
      } else {
        setClientName("");
      }
      setUnitOptions(filteredUnits);
    } catch (error) {
      setFailMessage("Error fetching unit IDs. Please try again.");
      console.error("Error fetching unit IDs:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUnitChange = (event) => {
    const unitID = event.target.value;
    setSelectedUnit(unitID);
    fetchForm(unitID);
  };

  const fetchForm = async (unit_id) => {
    setLoading(true);
    try {
      const response = await dispatch(getForm(unit_id));
      if (response.success === true) {
        setFailMessage("");
        setFormName(response.data);
      } else {
        setFailMessage(response.message);
        showSnackbar(response.message, "error"); // Display snackbar error message
      }
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Failed to fetch form details.");
      showSnackbar("Failed to fetch form details.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setSuccessMessage("");
    setFailMessage("");
    setLoading(true);

    try {
      const formattedDateForPayload = `${selectedDate}-01`;
      const user = JSON.parse(sessionStorage.getItem('user'));
      const company_code = user?.company_code;      
      const formDataInput = {
        client_id: clientID,
        unit_id: selectedUnit,
        date: date,
        form_type: selectedForm,
        client_name: clientName,
        company_code : company_code,
      };

      const result = await dispatch(CreateGenerateFormInput(formDataInput));

      if (result.success) {
        setSuccessMessage("Form Generated Successfully");
        showSnackbar("Form Generated Successfully", "success");
        setEmployeeData(result.message.data.data);
      } else {
        setFailMessage(result.message);
        showSnackbar(result.message, "error");
      }
    } catch (error) {
      console.error("Error generating form:", error);
      setFailMessage("No record found for given input. Please try again.");
      showSnackbar("No record found. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };
  const handleActsChange = (event) => {
    setActs(event.target.value);
  };

  const handleCLRAChange = (event) => {
    setClraAddress(event.target.value);
  };

  const handleFormTypeChange = (event) => {
    setSelectedForm(event.target.value);
  };

  const handleMonthChange = (event) => {
    const date = event.target.value;
    setSelectedDate(formattedDate);
  };
  const parsedDate = new Date(date);
  const formattedDate = parsedDate.toLocaleDateString('en-US', { year: 'numeric', month: 'short' });





  return (
    <div className="container-fluid pb-3">
      <div className="card generate-form-card mt-4 mb-5">
        <div className="card-body">
          <h1 className="card-title text-center mb-4">Generate Form</h1>
          <form onSubmit={handleFormSubmit}>
            <div className="mb-1">
              <label className="form-label">Organization ID</label>
              <input className="form-control" type="text" value={clientID } disabled/>
            </div>
            <div className="mb-1">
              <label className="form-label">Branch's</label>
              <select className="form-select " value={selectedUnit} onChange={handleUnitChange}>
                <option value="">Select Unit</option>
                {unitOptions.map((unit) => (
                  <option key={unit.unit_id} value={unit.unit_id}>
                    {unit.unit_id}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-1">
              <label className="form-label">Date</label>
              <input
                className="form-control"
                type="text"
                value={formattedDate}
                disabled
              />

            </div>
            <div className="mb-1">
              <label className="form-label">Form Type</label>
              <Select
                options={formOptions}
                value={formOptions.find(option => option.value === selectedForm)}
                onChange={(selectedOption) => handleFormTypeChange({ target: { value: selectedOption?.value } })}
                placeholder="Select Form Type"
                isSearchable
              />
            </div>
            {acts === "CLRA" && (
              <div className="mb-3">
                <label className="form-label">Principle Employer Address</label>
                <textarea className="form-control" value={clraAddress} onChange={handleCLRAChange} />
              </div>
            )}
            <button type="submit" className="btn btn-primary w-100">Generate FORM</button>
          </form>
          {successMessage && (
            <div className="alert alert-success mt-3">{successMessage}</div>
          )}
          {failMessage && <div className="alert alert-danger mt-3">{failMessage}</div>}
        </div>
      </div>
    </div>



  );
}

export default GenerateForm;
